import { render, staticRenderFns } from "./LiveCard.vue?vue&type=template&id=5cf48af2&"
import script from "./LiveCard.vue?vue&type=script&lang=js&"
export * from "./LiveCard.vue?vue&type=script&lang=js&"
import style0 from "./LiveCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports